<template>
  <el-table
    :data="data"
    border
    style="width: 100%"
    v-loading="loading"
  >
    <el-table-column
      prop="detailId"
      :label="$t('goldDetail.id')"
      align="center"
    />
    <el-table-column
      prop="goldName"
      :label="$t('goldDetail.goldAccount')"
      align="center"
    />
    <el-table-column
      prop="detailType"
      :label="$t('goldDetail.type')"
      align="center"
    >
      <template #default="{row}">
        {{ row.detailType === '1001' ? $t('goldDetail.transferIn') : $t('goldDetail.transferOut') }}
      </template>
    </el-table-column>
    <el-table-column
      prop="communityName"
      :label="$t('goldDetail.communityName')"
      align="center"
    />
    <el-table-column
      prop="communityId"
      :label="$t('goldDetail.communityId')"
      align="center"
    />
    <el-table-column
      prop="amount"
      :label="$t('goldDetail.transactionAmount')"
      align="center"
    />
    <el-table-column
      prop="totalAmount"
      :label="$t('goldDetail.currentAmount')"
      align="center"
    />
    <el-table-column
      prop="orderId"
      :label="$t('goldDetail.transactionNo')"
      align="center"
    />
    <el-table-column
      prop="remark"
      :label="$t('goldDetail.remark')"
      align="center"
    />
    <el-table-column
      prop="createTime"
      :label="$t('goldDetail.time')"
      align="center"
    />
  </el-table>
</template>

<script>
export default {
  name: 'GoldDetailTable',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>